module.exports = __webpack_public_path__ + "1af662d44ed81d46c3a4523e37c5f460.svg";